export class Origin {
    static get map(): string { return "productionplanning_arbetsordermap"; }
    static get gantt(): string { return "productionplanning_arbetsordergantt"; }
    static get list(): string { return "productionplanning_arbetsorderlist"; }
    static get listHeader(): string { return "productionplanning_arbetsorderlistHeader"; }
    static get detail(): string { return "productionplanning_arbetsorderdetail"; }
    static get popup(): string { return "productionplanning_arbetsorderpopup"; }
}
